import { render } from "./ControllerOperationGroupsList.vue?vue&type=template&id=85c2025c&scoped=true"
import script from "./ControllerOperationGroupsList.vue?vue&type=script&lang=js"
export * from "./ControllerOperationGroupsList.vue?vue&type=script&lang=js"

import "./ControllerOperationGroupsList.vue?vue&type=style&index=0&id=85c2025c&scoped=true&lang=css"

import exportComponent from "C:\\creatorcube-vue3\\CreatorCUBE\\CreatorCUBE_Controller\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85c2025c"]])

export default __exports__